import { TimeoutStepSchema } from '@feedyou/schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<TimeoutStepSchema> = (step, query) => {
  return searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      dialog: ['dialog', 'onTimeoutDialog'],
      text: ['condition']
    })
  )
}
